module.exports = __webpack_public_path__ + "static/media/jitu.c0bde7bc.png";